import React, { useEffect } from 'react'
import dayjs from 'dayjs';
import weekday from "dayjs/plugin/weekday"; // Import the plugin
import localeData from "dayjs/plugin/localeData"; // Import localeData plugin
import { useCurrencyConverter } from '../../context/currencyHook';
import { useCurrency } from '../../context/CurrencyContext';

dayjs.extend(localeData); // Extend dayjs with the plugin
dayjs.extend(weekday); // Extend dayjs with the plugin

function RentalSummary({ dateRange, perDayRent, setAmount = () => { }, selectedVehicle, title = 'Rental Summary', description = '', cn = '' }) {

  const convertCurrency = useCurrencyConverter();
  const { currency } = useCurrency();

  const date1 = dayjs(dateRange[0]);
  const date2 = dayjs(dateRange[1]);

  const diffInDays = date2.diff(date1, "day") || 0;

  useEffect(() => {
    setAmount(perDayRent * (Number(diffInDays) + 1))
  }, [perDayRent])

  return (
    <div>
      <div className={`text-center !text-white text-lg font-bold mt-4 ${cn}`} style={{ color: 'black', backgroundColor: '#00803e', margin: '1rem', marginTop: '2.5rem', marginBottom: '1rem' }}>
        {title}
      </div>
      <div className='text-center text-lg'>
        {description}
      </div>
      {/*  */}
      <div className="bg-white p-6 rounded-lg shadow-lg text-left m-[1rem] flex justify-center">
        <table className="lg:w-[50%] lg:ml-[9rem]">
          <tbody>
            <tr>
              <td className="font-semibold py-2 pr-2">Dates:</td>
              <td className="text-left">{dayjs(date1).format("DD-MMM-YYYY") + " to " + dayjs(date2).format("DD-MMM-YYYY")}</td>
            </tr>
            <tr>
              <td className="font-semibold py-2 pr-2">Days:</td>
              <td className="text-left">{Number(diffInDays) + 1}</td>
            </tr>
            <tr>
              <td className="font-semibold py-2 pr-2">Vehicle:</td>
              <td className="text-left">{selectedVehicle.name}</td>
            </tr>
            <tr>
              <td className="font-semibold py-2 pr-2">Vehicle passengers capacity:</td>
              <td className="text-left">{selectedVehicle.passengersCapacity} passengers</td>
            </tr>
            <tr>
              <td className="font-semibold py-2 pr-2">Vehicle luggage capacity:</td>
              <td className="text-left">{selectedVehicle.luggage}</td>
            </tr>
            <tr>
              <td className="font-semibold py-2 pr-2">Total:</td>
              <td className="text-left">{convertCurrency(perDayRent * (Number(diffInDays) + 1))} {currency}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  )
}

export default RentalSummary